// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loader{border-width:5px;box-sizing:border-box;animation:rotation 2s linear infinite;width:2rem;height:2rem;border-style:dotted;--border-opacity:1;border-color:#009d7f;border-color:rgba(0,157,127,var(--border-opacity));border-radius:9999px}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
